import React from 'react';
import MuiGrid, { GridProps } from '@material-ui/core/Grid';

const GridItem = function (props: GridProps) {
  return <MuiGrid item {...props} />;
};

export default GridItem;
